import { gql } from "@apollo/client";

export const RESIDENT_FIELDS = `
    id
    firstName
    lastName
    language
    dateOfBirth
    gender
    photoUrl
    admissionDate
    dischargeDate
    roomNumber
    status
    carePlan  {
        id
        medicalSummary {
          primaryDiagnosis
          secondaryDiagnoses
          allergies
          specialDiet
        }
        primaryDiagnosis
        secondaryDiagnoses
        allergies
        specialDiet
        riskLevel
        riskFactors
        mitigationStrategy
        mobilityStatus
        cognitiveStatus
        codeStatus
        preliminaryServicePlan
    }
    image {
      id
      url
      staffId
    }
`;

export const GET_RESIDENTS = gql`
  query GetResidents($businessId: ID!) {
    getResidents(businessId: $businessId) {
      id
      businessId

      # Identity & Admission
      firstName
      lastName
      gender
      language
      dateOfBirth
      admissionDate
      dischargeDate
      roomNumber
      status
      photoUrl

      # Insurance & Case Management
      primaryPayor
      insuranceType
      medicaidId
      medicareNumber
      mcoName

      caseManagerName
      caseManagerPhone
      caseManagerAgency

      socialWorkerName
      socialWorkerPhone
      socialWorkerAgency

      # Medical Providers
      pcpName
      pcpPhone
      preferredHospital

      pharmacyName
      pharmacyPhone

      # Emergency / Family / Legal
      emergencyContactName
      emergencyContactPhone

      familyContactName
      familyContactRelationship
      familyContactPhone

      poaName
      poaPhone
      poaType

      # Sensitive (UI masks this)
      ssn

      # Existing relations (kept intentionally)
      carePlan {
        id
        medicalSummary {
          primaryDiagnosis
          secondaryDiagnoses
          allergies
          specialDiet
        }
        primaryDiagnosis
        secondaryDiagnoses
        allergies
        specialDiet
        riskLevel
        riskFactors
        mitigationStrategy
        mobilityStatus
        cognitiveStatus
        codeStatus
        preliminaryServicePlan
      }
  
      image {
        id
        url
        staffId
      }
    }
  }
`;

export const CREATE_RESIDENT = gql`
  mutation CreateResident($data: ResidentInput!) {
    createResident(data: $data) {
      id
      firstName
      lastName
    }
  }
`;

export const GET_RESIDENT_BY_ID = gql`
  query GetResidentById($id: ID!) {
    getResidentById(id: $id) {
      id
      businessId

      firstName
      lastName
      gender
      language
      dateOfBirth
      admissionDate
      dischargeDate
      status
      roomNumber

      primaryPayor
      insuranceType
      medicaidId
      medicareNumber
      mcoName

      caseManagerName
      caseManagerPhone
      caseManagerAgency

      socialWorkerName
      socialWorkerPhone
      socialWorkerAgency

      pcpName
      pcpPhone
      preferredHospital

      pharmacyName
      pharmacyPhone

      emergencyContactName
      emergencyContactPhone

      familyContactName
      familyContactRelationship
      familyContactPhone

      poaName
      poaPhone
      poaType

      ssn

      carePlan {
        id
        medicalSummary {
          primaryDiagnosis
          secondaryDiagnoses
          allergies
          specialDiet
        }
        primaryDiagnosis
        secondaryDiagnoses
        allergies
        specialDiet
        riskLevel
        riskFactors
        mitigationStrategy
        mobilityStatus
        cognitiveStatus
        codeStatus
        preliminaryServicePlan
      }
    }
  }
`;

export const GET_DAILY_NOTES = gql`
  query GetDailyNotes($residentId: ID!) {
    getDailyNotes(residentId: $residentId) {
      id
      note
      createdAt
    }
  }
`;
export const GET_CARE_HISTORY = gql`
  query GetCareHistory($residentId: ID!) {
    residentCareHistory(residentId: $residentId) {
      id
      date
      category
      incident
      trigger
      intervention
      outcome
      followUp
      recordedBy
      incidentRequired
    }
  }
`;
export const UPDATE_CARE_HISTORY = gql`
  mutation UpdateCareHistoryEntry($id: ID!, $data: ResidentCareHistoryInput!) {
    updateCareHistoryEntry(id: $id, data: $data) {
      id
      date
      category
      incidentRequired
    }
  }
`;
export const ADD_CARE_HISTORY = gql`
  mutation AddCareHistoryEntry($data: ResidentCareHistoryInput!) {
    addCareHistoryEntry(data: $data) {
      id
      date
      category
      incidentRequired
    }
  }
`;
export const ADD_DAILY_NOTE = gql`
  mutation AddDailyNote($data: DailyNoteInput!) {
    addDailyNote(data: $data) {
      id
      note
      createdAt
    }
  }
`;
export const POST_RESIDENT = gql`
  mutation CreateResident($data: ResidentInput!) {
    createResident(data: $data) {
      id
      firstName
      lastName
      gender
      dateOfBirth
      admissionDate
      status
    }
  }
`;

export const UPDATE_RESIDENT = gql`
  mutation UpdateResident($id: ID!, $data: ResidentInput!) {
    updateResident(id: $id, data: $data) {
      id
      firstName
      lastName
      gender
      language
      dateOfBirth
      admissionDate
      dischargeDate
      roomNumber
      status
    }
  }
`;

export const DEACTIVATE_RESIDENT = gql`
  mutation DeactivateResident($id: ID!) {
    deactivateResident(id: $id)
  }
`;
